export const HOME = "/";
export const DOCS = "/doc/overview";
export const PRICING = "/pricing";
export const UPDATES = "/updates";
export const BLOG = "/blog";
export const CONTACT = "/contact";
export const PREMIUM = "/premium";
export const TEAMS = "/teams";
export const PRIVACY_POLICY = "/privacy-policy";
export const PRIVACY_POLICY_PREVIOUS = "/privacy-policy-previous";
export const TERMS = "/terms-of-service";

export const LOGIN = "/account/login";
export const REGISTER = "/account/register";
export const FORGOT_PASSWORD = "/account/forgotpassword";
export const RESET_PASSWORD = "/account/resetpassword/";
export const PLEASE_VERIFY = "/account/pleaseverify";
export const VERIFY = "/account/verify/";

export const DB_USER_HOME = "/dashboard/accounts";
export const DB_USER_ORGS = "/dashboard/accounts";
export const DB_USER_CREATEORG = "/dashboard/createorg";
export const DB_USER_SETTINGS = "/dashboard/usersettings";

export const DB_ORG_HOME = "/dashboard/org/:orgId/home";
export const DB_ORG_SETTINGS = "/dashboard/org/:orgId/settings";
export const DB_ORG_SERMONS = "/dashboard/org/:orgId/sermons";
export const DB_ORG_PRAYER = "/dashboard/org/:orgId/prayer";
export const DB_ORG_TITHE = "/dashboard/org/:orgId/tithe";

export const DB_ORG_SONGS = "/dashboard/org/:orgId/songs/";
export const DB_ORG_SONG = "/dashboard/org/:orgId/songs/:songId";
export const DB_ORG_PERSONS = "/dashboard/org/:orgId/person/";
export const DB_ORG_PERSON = "/dashboard/org/:orgId/person/:personId";
export const DB_ORG_SERVICES = "/dashboard/org/:orgId/service/";
export const DB_ORG_SERVICE = "/dashboard/org/:orgId/service/:serviceId";


// \:.+?\:



// WEBPACK FOOTER //
// ./src/constants/Paths.js